import loadingMessageManager from './loadingMessageManager';

const headTag = document.getElementsByTagName('HEAD')[0];

const appendPlayerScript = () => {
    const { playerUrl } = window.playerStartupConfig;
    const script = document.createElement('script');

    script.onerror = loadingMessageManager.showFailMessage;
    script.setAttribute('src', playerUrl);
    headTag.appendChild(script);
};

const appendPlayerStyle = () => {
    const { playerCss } = window.playerStartupConfig;
    const linkScript = document.createElement('link');

    linkScript.rel = 'stylesheet';
    linkScript.type = 'text/css';
    linkScript.href = playerCss;
    headTag.appendChild(linkScript);
};

const scriptLoader = {
    load() {
        appendPlayerScript();
        appendPlayerStyle();
    },
};

export default scriptLoader;
